<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
      <div class="title-container">
        <img src="../../assets/images/login/logo.png" alt />
        <h3 class="title">商户管理平台</h3>
      </div>

      <el-form-item prop="userName">
        <div class="label">账号</div>
        <el-input v-model="loginForm.userName" placeholder="账号" name="username" type="text" />
      </el-form-item>

      <el-form-item prop="password">
        <div class="label">密码</div>
        <el-input v-model="loginForm.password" type="password" placeholder="密码" name="password" />
      </el-form-item>

      <el-form-item prop="code" class="code">
        <div class="label">验证码</div>
        <el-input v-model="loginForm.code" placeholder="验证码" name="code" type="text" />
        <div class="img">
          <img :src="loginForm.codeImg" alt @click="getCodeImg" />
        </div>
      </el-form-item>

      <el-button :disabled="disabledBtn" :loading="loading" type="primary" @click.native.prevent="doLogin">登录</el-button>
      <div class="tips" @click="goModifyPwd">忘记密码</div>
    </el-form>
  </div>
</template>

<script>
import { getCodeImg, login } from '@/api/login';

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 8 || value.length > 16) {
        callback(new Error('密码必须是8-16个字符'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        userName: '',
        password: '',
        code: '',
        sess: '',
        codeImg: '',
      },
      loginRules: {
        userName: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        code: [{ required: true, trigger: 'blur', validator: validateCode }],
      },
      loading: false,
    };
  },
  computed: {
    disabledBtn() {
      return !(this.loginForm.userName && this.loginForm.password.length >= 8 && this.loginForm.password.length <= 16 && this.loginForm.code);
    },
    accessRoutes() {
      return this.$store.state.permission.addRoutes;
    },
  },
  methods: {
    doLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = Object.assign({}, this.loginForm);
          params.password = this.$md5(params.password);
          login(params).then((res) => {
            if (res.data.error_code === 0) {
              const loginInfo = {
                sessionId: res.data.data.sessionId, userName: res.data.data.userName, merchantName: res.data.data.merchantName, shopType: res.data.data.shopType, userRole: res.data.data.userRole, merchantId: res.data.data.merchantId, groupType: res.data.data.groupType,
              };
              const authRoute = res.data.data.authorityList;
              window.localStorage.setItem('LOGIN_INFO', JSON.stringify(loginInfo));
              window.localStorage.setItem('authRoute', JSON.stringify(authRoute));
              this.$store.dispatch('permission/generateRoutes');
              this.$router.options.routes = this.$router.options.routes.concat(this.accessRoutes);
              this.$router.addRoutes(this.accessRoutes);
              const indexPath = `${authRoute[0].path}/${authRoute[0].children[0].path}`;
              this.$router.push({ path: indexPath });
            } else {
              this.getCodeImg();
            }

            this.loading = false;
          });
        }
      });
    },
    goModifyPwd() {
      this.$router.push({ path: '/forgetPwd' });
    },
    getCodeImg() {
      getCodeImg().then((res) => {
        if (res.data.error_code === 0) {
          this.loginForm.codeImg = res.data.data.middleUrl;
          this.loginForm.sess = res.data.data.sess;
        }
      });
    },
  },
  created() {
    this.getCodeImg();
  },
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    height: 47px;
    text-align: center;
    input {
      background: transparent;
      // border: 1px solid #E8EAEC;
      -webkit-appearance: none;
      border-radius: 4px;
      // padding: 12px 5px 12px 80px;
      padding-left: 80px;
      height: 47px;
      width: 430px;
      color: #000;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #000 !important;
      }
    }
  }

  .el-form-item {
    .el-form-item__content {
      .label {
        position: absolute;
        height: 47px;
        line-height: 47px;
        padding: 0 20px;
        color: #666666;
        font-size: 14px;
        z-index: 10;
      }
    }
    &.code {
      .el-form-item__content {
        display: flex;
        .el-input {
          flex: 3;
          input {
            width: 100%;
          }
        }
        .img {
          padding-left: 14px;
          flex: 1;
          height: 50px;
          img {
            cursor: pointer;
            height: 47px;
            width: 133px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.login-container {
  min-height: 100%;
  width: 100%;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(../../assets/images/login/bg.png);
  overflow: hidden;

  .login-form {
    position: absolute;
    border-radius: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 530px;
    height: 610px;
    max-width: 100%;
    background-color: #fff;
    padding: 50px;
    overflow: hidden;
    .el-button--primary {
      background-color: #ffa300;
      border: none;
      width: 100%;
      height: 52px;
      border-radius: 6px;
      margin-bottom: 30px;
      &.is-disabled {
        background-color: #e5e5e5;
        color: #a7a7a7;
      }
    }
  }

  .tips {
    font-size: 14px;
    color: #868686;
    text-align: center;
    cursor: pointer;
  }

  .title-container {
    position: relative;
    text-align: center;
    img {
      display: block;
      margin: 0 auto;
    }
    .title {
      font-size: 16px;
      color: #000033;
      margin: 10px auto 50px auto;
      text-align: center;
    }
  }
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #999;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #999;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #999;
  }
}
</style>
